module.exports = __webpack_public_path__ + "img/compu.12e13111.svg";